import React from 'react';
import {DeliveryMethodStepDataHook} from '../DeliveryMethodStep';

export const DeliveryMethodEmpty = () => {
  return <div data-hook={DeliveryMethodStepDataHook.empty} />;
};
